import { createApp } from 'vue';
import TestBlock from './components/HeaderBlock.vue';
import FeaturesBlock from './components/FeaturesBlock.vue';
import InfoBlock from './components/InfoBlock.vue';
import './assets/scss/app.scss';

const components = {
    'header-block': TestBlock,
    'features-block': FeaturesBlock,
    'info-block': InfoBlock
};

Object.entries(components).forEach(([name, component]) => {
    document.querySelectorAll(`[data-vue-component="${name}"]`).forEach(el => {
        const props = el.dataset.props ? JSON.parse(el.dataset.props) : {}
        el.removeAttribute('data-props');
        createApp(component, props).mount(el);
    });
})


